import React from 'react';
import { Button, Col, Input, message, Modal, QRCode, Row, Space, Typography } from 'antd';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import CountDownTimer from '@/components/CountDown';
import { PayType } from '@/types/payment';

export interface PaymentModalProps {
  open: boolean;
  addressType: number;
  amount: number | string;
  address: string;
  endTime: string;
  onClose: () => void;
  centered?: boolean;
  purpose?: '支付' | '充值';
}

const PaymentModal: React.FC<PaymentModalProps> = ({
  open, addressType, amount, address, endTime, onClose,
  centered = true, purpose = '支付',
}) => {
  const [messageApi, contextHolder] = message.useMessage();
  const network = addressType === PayType.Dogecoin
    ? 'Dogecoin'
    : addressType === PayType.Ethereum
      ? 'ERC-20'
      : addressType === PayType.Tron
        ? 'TRC-20'
        : undefined;
  const addressFields = (
    <>
      <Typography.Text strong>
        {network && `请寄到以下地址 (${network} Network Only)：`}
      </Typography.Text>
      <Space.Compact style={{ width: '100%' }}>
        <Input value={address} readOnly />
        <CopyToClipboard text={address} onCopy={(_text, success) => {
          if (success) {
            messageApi.success(purpose === '充值' ? '地址已复制到剪贴板' : '收款地址已成功复制到剪贴板');
          } else {
            messageApi.warning('复制失败，请手动复制收款地址');
          }
        }}>
          <Button>复制地址</Button>
        </CopyToClipboard>
      </Space.Compact>
    </>
  );

  return (
    <>
      {contextHolder}
      <Modal
        title={
          <div>
            <Typography.Title level={4} style={{ margin: 0 }}>
              {addressType === PayType.Dogecoin ? 'Dogecoin' : 'tether'}
            </Typography.Title>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <p style={{ color: 'red', fontSize: '14px' }}>
                请在有效时间内完成支付交易，支付时间超时，则支付金额无效
              </p>
              <p style={{ fontSize: '14px' }}>
                {open && <CountDownTimer targetDate={endTime || undefined} onEnd={onClose} />}
              </p>
            </div>
          </div>
        }
        open={open}
        destroyOnHidden
        onCancel={onClose}
        footer={null}
        centered={centered}
        width={600}
      >
        <Row gutter={[16, 16]} align="middle">
          <Col span={24}>
            <Typography.Text strong>需要支付</Typography.Text>
            <Typography.Title level={2} style={{ margin: 0, color: 'red' }}>
              {amount}
              <span style={{ marginLeft: '6px', color: 'black', fontSize: '18px', fontWeight: 'bold' }}>
                {addressType === PayType.Dogecoin ? 'DOGE' : 'USDT'}
              </span>
            </Typography.Title>
            {purpose === '充值' ? addressFields : (
              <Typography.Text strong type="danger">
                请支付正确的货币金额，否则系统无法确认是否到账
              </Typography.Text>
            )}
          </Col>
          {purpose === '支付' && <Col span={24}>{addressFields}</Col>}
          <Col span={24}>
            <Typography.Text strong>
              请核对复制后的地址是否一致（支付地址错误用户自行承担损失）
            </Typography.Text>
          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            <div style={{ padding: '10px', backgroundColor: '#f5f5f5', display: 'inline-block', borderRadius: '10px' }}>
              <QRCode value={address || ''} size={200} />
            </div>
          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            <Typography.Text type="secondary">请于 {endTime} 前完成{purpose}</Typography.Text>
          </Col>
          <Col span={24} style={{ textAlign: 'center' }}>
            <Typography.Text type="secondary">
              支付完成之后，不要关闭此弹窗，系统确认会更快些，只需1-2分钟即可
            </Typography.Text>
          </Col>
        </Row>
      </Modal>
    </>
  );
};

export default PaymentModal;
